import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { App } from "./App";
import { LoginPage } from "./pages/LoginPage";
import { PortfoliosListPage } from "./pages/PortfoliosListPage";
import { PortfolioBuilderPage } from "./pages/PortfolioBuilderPage";
import { WatchlistPage } from "./pages/WatchlistPage";
import { AuthProvider, useAuth } from "./auth";
import "./styles.css";
import "./aikido.css";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { token } = useAuth();
  return token ? <>{children}</> : <Navigate to="/login" replace />;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<App />}>
            <Route index element={<Navigate to="/watchlist" replace />} />
            <Route path="login" element={<LoginPage />} />
            <Route
              path="watchlist"
              element={
                <RequireAuth>
                  <WatchlistPage />
                </RequireAuth>
              }
            />
            <Route
              path="portfolios"
              element={
                <RequireAuth>
                  <PortfoliosListPage />
                </RequireAuth>
              }
            />
            <Route
              path="portfolios/new"
              element={
                <RequireAuth>
                  <PortfolioBuilderPage />
                </RequireAuth>
              }
            />
            <Route
              path="portfolios/:id"
              element={
                <RequireAuth>
                  <PortfolioBuilderPage />
                </RequireAuth>
              }
            />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
